import { useSelector } from "react-redux";

const useService = (serviceRef) => {
  return useSelector((state) => state.services[serviceRef]);
};

export default useService;
